import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

type Props = {
  children: React.ReactElement
  placement?: 'top' | 'right' | 'bottom' | 'left'
  message?: string
}
const WipTooltip: React.FC<Props> = ({children, placement, message}) => {
  placement = placement || 'right'
  const {t} = useTranslation()
  return <Tooltip
    title={message || t('general.wip')}
    placement={placement}
    enterTouchDelay={0}
    arrow
  >
    {children}
  </Tooltip>
}
export default WipTooltip